module.exports = __webpack_public_path__ + "static/media/guanyinshan1.135ba855.webp";